import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import Dashboard from './pages/Dashboard';
import CapitalGain from './pages/CapitalGain';
import TDSCalculator from './pages/TDSCalculator';
import Navbar from './components/Navbar';

function App() {
  return (
    <Router>
      <div className="min-h-screen bg-gray-50">
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/tools/capital-gain" element={<CapitalGain />} />
          <Route path="/tools/tds-calculator" element={<TDSCalculator />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
